export default {
  methods: {
    getDefaultStartDate(date) {
      date.setMonth(date.getMonth() - 2);
      return date.toISOString().substring(0, 10);
    },

    getDefaultEndDate(date) {
      return date.toISOString().substring(0, 10);
    },
  },
};
